export default function({ store }) {
 	return store.dispatch('slideshow/getSlideshowList');
}